var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { CircularProgress, Grid } from "@mui/material";
import { useCallback, useEffect, useMemo } from "react";
import { deleteState } from "../../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { getLoadingKey, getUpdateKey } from "../../../common/commonFunctions";
import { DynamicFormBuilderContainer } from "../formBuilder/dynamicFormBuilder.container";
var emptyFunction = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/];
}); }); };
var defaultGetRowId = function (row) { return row === null || row === void 0 ? void 0 : row.id; };
export default function FormIterator(props) {
    var _crud$apiKey, _getOnChange;
    var crud = useAppSelector(function (state) { return state.crud; });
    var name = props.name, error = props.error, disabled = props.disabled, _a = props.getRowId, getRowId = _a === void 0 ? defaultGetRowId : _a, getListData = props.getListData, _b = props.apiKey, apiKey = _b === void 0 ? "_".concat(name) : _b, apiRequest = props.apiRequest, elements = props.elements, gridItemProps = props.gridItemProps, _c = props.value, value = _c === void 0 ? (_crud$apiKey = crud[apiKey]) === null || _crud$apiKey === void 0 ? void 0 : _crud$apiKey.data : _c, processItemUpdate = props.processItemUpdate, getOnChange = props.getOnChange;
    var dispatch = useAppDispatch();
    var updateKey = getUpdateKey(apiKey);
    var loadingKey = getLoadingKey(apiKey);
    var isLoading = crud[loadingKey] === 'loading';
    // const valuesLookup = useMemo(() => {
    //     if (!value) return value
    //     let map = new Map(value.map(it => [getRowId(it), it]))
    //     return map
    // }, [value])
    var onChange = (_getOnChange = getOnChange === null || getOnChange === void 0 ? void 0 : getOnChange(props)) !== null && _getOnChange !== void 0 ? _getOnChange : emptyFunction;
    useEffect(function () {
        if (crud[updateKey]) {
            getListData === null || getListData === void 0 || getListData({
                key: apiKey,
                request: apiRequest
            });
            dispatch(deleteState({
                key: updateKey
            }));
        }
        return function () {
            // clear redux keys state on unmount
            if (!crud[updateKey]) {
                dispatch(deleteState({
                    key: apiKey
                }));
                dispatch(deleteState({
                    key: updateKey
                }));
            }
        };
    }, [crud[updateKey]]);
    useEffect(function () {
        getListData === null || getListData === void 0 || getListData({
            key: apiKey,
            request: apiRequest
        });
    }, []);
    var updateRow = useCallback(function (e, item) {
        var newValue = value === null || value === void 0 ? void 0 : value.map(function (r) {
            if (getRowId(r) === getRowId(item)) {
                return _objectSpread({}, item);
            }
            else {
                return _objectSpread({}, r);
            }
        });
        onChange === null || onChange === void 0 || onChange(e, newValue);
    }, [value, onChange, getRowId]);
    var handleItemChange = useCallback(function (e, _ref) {
        var _a;
        var _field$name;
        var state = _ref.state, value = _ref.value, field = _ref.field;
        if (processItemUpdate) {
            var itemParams = {
                state: state,
                value: value,
                field: field,
                error: error
            };
            var itemUpdate = processItemUpdate(itemParams);
            updateRow(e, itemUpdate);
            return itemUpdate;
        }
        updateRow(e, _objectSpread(_objectSpread({}, state), {}, (_a = {},
            _a[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : ''] = value,
            _a)));
    }, [updateRow, value, processItemUpdate, error, onChange]);
    var memoItems = useMemo(function () { return value === null || value === void 0 ? void 0 : value.map(function (item) { /*#__PURE__*/ return React.createElement(IteratorItem, {
        item: item,
        elements: elements,
        getRowId: getRowId,
        gridItemProps: gridItemProps,
        disabled: disabled,
        error: error,
        onItemChange: handleItemChange
    }); }); }, [value, handleItemChange, error === null || error === void 0 ? void 0 : error.id]);
    return isLoading ? /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        container: true,
        justifyContent: "center"
    }, /*#__PURE__*/ React.createElement(CircularProgress, {
        size: 20
    })) : memoItems;
}
;
var IteratorItem = function (props) {
    var _a;
    var elements = props.elements, item = props.item, gridItemProps = props.gridItemProps, _b = props.getRowId, getRowId = _b === void 0 ? defaultGetRowId : _b, disabled = props.disabled, error = props.error, onItemChange = props.onItemChange;
    return (elements === null || elements === void 0 ? void 0 : elements.length) && /*#__PURE__*/ React.createElement(Grid, _extends({
        item: true
    }, gridItemProps, {
        key: getRowId(item)
    }), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: disabled ? 'view' : 'edit',
        formData: elements,
        state: item,
        errors: error && error.rowId === getRowId(item) ? (_a = {
                id: error.id
            },
            _a[error.field] = error.message,
            _a) : undefined,
        onChange: onItemChange,
        gridSpacing: 0
    }));
};
